import clsx from "clsx";
import { TextProps } from "./PropsTypes";

export default function TextLink({ children, className, onClick }: TextProps) {
	return (
		<a
			className={clsx("link-text", className)}
			onClick={(e) => {
				e.preventDefault();
				onClick?.();
			}}
		>
			{children}
		</a>
	);
}
